<template>
  <Overlay :show="show">
    <main class="info-affirm">
      <header class="header">
        <img class="background" :src="background" />
        <div class="title1">
          <i class="iconfont icon-close" @click="onclose"></i>
          <h3 class="name">个人信息确认</h3>
        </div>
      </header>
      <section class="content">
        <div class="tips">
          <img src="@/assets/error.png" width="21" height="21" />
          <!-- <span class="iconfont iconcuowu iconi"></span> -->
          <span class="text">请核实您的个人信息，如果信息有误，申请的学时证书将无效</span>
        </div>
        <div class="userinfo">
          <div class="userinfo-item">
            <span class="topic">姓名</span>
            <span class="result" v-if="userInfo">{{ userInfo.name }}</span>
          </div>
          <div class="userinfo-item current">
            <span class="topic">机构</span>
            <span class="result" v-if="userInfo">{{ userInfo.orgName }}</span>
          </div>
        </div>
        <div class="btn confirm" @click="onclose">确认无误</div>
        <div class="btn edit" @click="handleJumpUserinfo">立即修改</div>
      </section>
    </main>
  </Overlay>
</template>

<script>
import {Overlay} from 'vant'
export default {
  name: 'info-affirm',
  components: {
    Overlay
  },
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      background: require('../../assets/image/customization/info-affirm-background.png')
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    handleJumpUserinfo() {
      this.$router.push('/customization/user-info')
    },
    onclose() {
      this.$emit('on-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-affirm {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  border-radius: 10px;
  background: #fff;
  .header {
    position: relative;
    width: 100%;
    height: 72px;
    border-radius: 10px 10px 0 0;
    .background {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px 10px 0 0;
      z-index: 9;
    }
    .title1 {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 72px;
      color: #fff;
      border-radius: 10px 10px 0 0;
      z-index: 10;
      i {
        position: absolute;
        right: 15px;
        top: -15px;
        font-size: 21px;
      }
      .name {
        font-size: 17px;
        font-weight: 600;
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 350px;
    padding: 20px 16px;
    box-sizing: border-box;
    .tips {
      position: relative;
      width: 100%;
      padding: 10.5px 8px;
      background: rgba(245, 63, 63, 0.1);
      border-radius: 6px;
      /* .iconi {
        vertical-align: middle;
        font-size: 21px;
        color: #f53f3f;
      } */
      img {
        position: absolute;
        left: 10px;
        top: 10px;
      }
      .text {
        display: flex;
        width: 210px;
        margin-left: 30px;
        font-size: 15px;
        line-height: 23px;
        color: #f53f3f;
      }
    }
    .userinfo {
      margin-top: 16px;
      width: 100%;
      padding: 16px 10px;
      box-sizing: border-box;
      background: #f8f8f8;
      border-radius: 6px;
      .userinfo-item {
        font-size: 15px;
        &.current {
          margin-top: 12px;
        }
        .topic {
          color: #808080;
        }
        .result {
          margin-left: 12px;
          color: #1a1a1a;
        }
      }
    }
    .btn {
      margin-top: 18px;
      width: 240px;
      height: 40px;
      border-radius: 25px;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      box-sizing: border-box;
      &.confirm {
        color: #fff;
        background: linear-gradient(90deg, #4a86f6 0%, #4465f3 100%);
      }
      &.edit {
        border: 1px solid #e5e5e5;
        color: #1a1a1a;
      }
    }
  }
}
</style>
